import { UserLocationODataRepo, UserLocationRepo } from "../../data/repo";
import { UserLocationModel } from "../../data/entities";
import { BaseEntityService } from "../BaseEntityService"

export class UserLocationService extends BaseEntityService<UserLocationModel, UserLocationRepo, UserLocationODataRepo> {
  constructor(){
    super(new UserLocationRepo(), new UserLocationODataRepo());
  }

  async getByUserIdAsync(userId:number) : Promise<UserLocationModel[]>{
    return await this.repo.getByUserIdAsync(userId);
  }
  async getUsersByLocationAsync(locationId: number | string) : Promise<UserLocationModel[]>{
    return await this.repo.getUsersByLocationAsync(locationId);
  }
}

export default UserLocationService;
